import { AddToAppleWalletBadge } from "../../common/icons";
import MockQRCode from "./MockQRCode";
import { CircleCheckBig, Download } from "lucide-react";

import { useMediaQuery } from "@punchup/utils/hooks";

interface Props {
  onButtonClick: () => void;
}

export const PurchaseCompleted = ({ onButtonClick }: Props) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const email = "hello@punchup.live";

  const onDownloadClick = () => {
    // TODO: download the ticket
  };

  return (
    <div className="px-6 pt-4 pb-12 md:py-20 md:px-36 flex flex-col gap-12">
      <div className="flex flex-col gap-8 items-center md:min-w-[700px]">
        <div className="flex flex-col gap-6 items-center w-full">
          <div className="flex flex-col gap-3 items-center">
            <div className="flex flex-row gap-1 bg-[#E6FFE6] p-4 rounded-full">
              <CircleCheckBig className="w-8 h-8 text-[#37A93C]" />
            </div>
            <h1 className="text-primary-blue text-xl md:text-2xl font-bold font-sans normal-case">
              Purchase completed!
            </h1>
          </div>
          <div className="bg-[#EAEAEA] rounded-lg py-2 px-7 flex flex-row gap-2">
            <p className="text-primary-blue font-medium">Order number:</p>
            <p className="text-primary-blue font-bold">3344</p>
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-secondary-blue font-light text-center">
            Your purchase is complete. Expect an email at{" "}
            <span className="underline underline-offset-2">{email}</span>
          </p>
          <p className="text-secondary-blue font-light text-center">
            with your ticket information in the next 10 minutes.
          </p>
        </div>
        <div className="md:w-[500px] flex flex-col gap-4">
          {isDesktop ? (
            <div className="flex flex-col gap-4 items-center justify-center">
              <div className="flex flex-col items-center justify-center gap-2 bg-black p-3 rounded-lg">
                <p className="font-semibold text-white text-[14px] leading-none pb-1">
                  Scan with your iPhone
                </p>
                <AddToAppleWalletBadge height={50} width={158.126} />
                <MockQRCode
                  height={158.126}
                  width={158.126}
                  className="rounded-lg"
                />
              </div>
              <button
                type="button"
                className="justify-self-end btn px-0 py-2.5 h-[50px] w-[158.126px] text-[13px] font-medium flex flex-row gap-2 items-center justify-center"
                onClick={onDownloadClick}
              >
                <Download width={24} height={24} /> Download Ticket
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-2 items-center justify-center gap-4 w-full">
              <button
                type="button"
                className="justify-self-end btn px-0 py-2.5 h-[50px] w-[158.126px] text-[13px] font-medium flex flex-row gap-2 items-center justify-center"
                onClick={onDownloadClick}
              >
                <Download width={24} height={24} /> Download Ticket
              </button>
              <button type="button" className="justify-self-start">
                <AddToAppleWalletBadge height={50} width={158.126} />
              </button>
            </div>
          )}
          <button
            type="button"
            className="py-2 text-[14px] underline text-primary underline-offset-1 font-bold"
            onClick={onButtonClick}
          >
            Return to Punchup
          </button>
        </div>
      </div>
    </div>
  );
};
